module.exports = __webpack_public_path__ + "media/theme/mobage-89dda74b.png";